<template>
  <div id="app">
    <Header />
    <section class="container-wrap">
      <MenuLeft />
      <section class="content">
        <router-view :key="$route.fullPath"></router-view>
      </section>
    </section>
  </div>
</template>
<script>
import Header from "@/components/Header";
import MenuLeft from "@/components/MenuLeft";
export default {
  components: {
    Header,
    MenuLeft
  }
};
</script>

<style lang="sass">
@import "../../assets/scss/common.scss"
#app
    min-height: 100vh
    display: flex
    flex-direction: column

.container-wrap
    display: flex
    box-sizing: border-box
    flex: 1
    & > .menu-left
        flex-basis: 260px
    .content
        box-sizing: border-box
        padding: 20px 40px
        flex: 1
</style>
